import { LinearProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useAdminLoading } from "./AdminLoadingContext";

export const AdminShellLoadingBar = () => {
  const { isLoading } = useAdminLoading();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setIsVisible(false);
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isLoading]);

  return (
    <div
      aria-hidden={!isVisible}
      className={`admin-shell-loading-strip${isVisible ? " is-visible" : ""}`}
    >
      <LinearProgress
        className="admin-shell-loading-bar"
        sx={{
          "& .MuiLinearProgress-bar": {
            backgroundColor: "var(--admin-accent)",
          },
          backgroundColor: "var(--admin-accent-soft)",
        }}
      />
    </div>
  );
};
